import { SET_UI_LOADING } from './actionTypes';

export const setPageLoading = (isLoading: boolean) => {
  return {
    type: SET_UI_LOADING,
    isLoading
  };
};